import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getPolicyCategory = async (params) => {
  return await api.post("/v1/announcement/getPolicyCategory", params);
};

export const createPolicyCategory = async (params) => {
  return await api.post("/v1/announcement/createPolicyCategory", params);
};

export const updatePolicyCategory = async (params) => {
  return await api.post("/v1/announcement/updatePolicyCategory", params);
};

export const managePolicyCategoryStatus = async (params) => {
  return await api.post("/v1/announcement/managePolicyCategoryStatus", params);
};


export const getPolicyByCategory = async (params) => {
  return await api.post("/v1/announcement/getPolicyByCategory", params);
};

export const getPolicyByCategoryHome = async (params) => {
  return await api.post("/v1/announcement/getPolicyByCategoryHome", params);
};

export const getAnnouncementPolicyPaging = async (params) => {
  return await api.post("/v1/announcement/getAnnouncementPolicyPaging", params);
};

export const getAnnouncementPolicy = async (params) => {
  return await api.post("/v1/announcement/getAnnouncementPolicy", params);
};

export const createAnnouncementPolicy = async (params) => {
  return await apiFormData.post(
    "/v1/announcement/createAnnouncementPolicy",
    params,
    {
      isFormData: true,
    }
  );
};

export const updateAnnouncementPolicy = async (params) => {
  return await apiFormData.post(
    "/v1/announcement/updateAnnouncementPolicy",
    params,
    {
      isFormData: true,
    }
  );
};

export const manageAnnouncementPolicyStatus = async (params) => {
  return await api.post(
    "/v1/announcement/manageAnnouncementPolicyStatus",
    params
  );
};

export const closeAnnouncementPolicy = async (params = {}) => {
  return await api.post("/v1/announcement/closeAnnouncementPolicy", params);
};

export const deleteAnnouncementPolicy = async (params = {}) => {
  return await api.post("/v1/announcement/deleteAnnouncementPolicy", params);
};
